import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons"

export const CommentAlt = (props) => {
  return <FontAwesomeIcon faIcon={faCommentAlt} {...props} />
}
